import React, {PureComponent} from 'react';
import {DatePicker, ConfigProvider} from 'antd';
import {connect} from "react-redux";

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb, i18} from '../../../Utilities';

import moment from 'moment';
// eslint-disable-next-line no-unused-vars
import lt from 'moment/locale/lt';
// eslint-disable-next-line no-unused-vars
import en from 'moment/locale/en-gb';
// eslint-disable-next-line no-unused-vars
import ru from 'moment/locale/ru';

import enUS from 'antd/lib/locale/en_US';
import ltLT from 'antd/lib/locale/lt_LT';
import ruRU from 'antd/lib/locale/ru_RU';

class DateFormField extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            prevFormat: null,
        }
    }

    render() {
        const {
            language,
            title,
            titleWithoutTranslate,
            className,
            classNameTitle,
            classNameField,
            inline,
            placeholder,
            minDate,
            maxDate,
            disabled,
            meta,
            dontAllowClear,
            input,
            small
        } = this.props

        let validDate;
        let locale = ltLT;

        switch (language) {
            case 'ru-RU':
                moment.locale('ru', {
                    week: {
                        dow: 1,
                    }
                });
                locale = ruRU;
                break;
            case 'lt-LT':
                moment.locale('lt', {
                    week: {
                        dow: 1,
                    }
                });
                locale = ltLT;
                break;
            case 'en-GB':
                moment.locale('en', {
                    week: {
                        dow: 1,
                    }
                });
                locale = enUS;
                break;
            default:
                moment.locale('lt', {
                    week: {
                        dow: 1,
                    }
                });
        }

        if (minDate && maxDate) {
            validDate = (current) => {
                return !current.isBetween(moment(minDate).endOf('day').subtract(1, 'day').endOf('day'), moment(maxDate).endOf('day'), null, '[]');
            };
        } else if (minDate) {
            validDate = (current) => {
                return current.isSameOrBefore(moment(maxDate).subtract(1, 'day').endOf('day'));
            };
        } else if (maxDate) {
            validDate = (current) => {
                return current.isSameOrAfter(moment(maxDate).endOf("day"));
            };
        } else {
            validDate = () => {
                return undefined;
            }
        }

        const currentFormat = moment.localeData().longDateFormat('L'),
        onChangeFormat = (moment, date) => {
            input.onChange(date);
        };
        let value;
        if (input.value) {
            value = moment(input.value) || moment(input.value, currentFormat);
        }
        else if(dontAllowClear){
            value = moment();
            input.onChange(value.format(currentFormat));
        }

        return <div className={FormFieldWrapperClasses(className, inline, disabled, false, small)}>
            {title && <div className={
                classNameTitle
                ? 'form-field-title ' + classNameTitle
                : inline
                    ? (className && className.indexOf('col-12') === -1) || (className && className.indexOf('col-12') !== -1 && className.indexOf('col-md-') !== -1)
                        ? 'form-field-title col-12 col-md-5 text-left text-md-right pb-2 pb-md-0 pr-md-0'
                        : 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0'
                    : 'form-field-title col-12'
            }>{titleWithoutTranslate ? title : trb(title)}</div>}
            <div className={
                classNameField
                    ? 'form-field-item ' + classNameField
                    : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>

                <ConfigProvider locale={locale}>
                    <DatePicker
                        placeholder={placeholder ? trb(placeholder) : trb(i18.Labels.SelectDate)}
                        disabled={disabled}
                        name={input.name}
                        value={value}
                        onChange={onChangeFormat}
                        disabledDate={validDate}
                        format={currentFormat}
                        showToday={false}
                        allowClear={!dontAllowClear}
                        getPopupContainer={() => document.getElementById('card')}
                    />
                </ConfigProvider>
            </div>
            <div className={inline ? 'form-field-error col-12 text-right' : 'form-field-error col-12 text-right'}>{meta.touched && (meta.error || meta.submitError)}</div>
        </div>
    };
}

function mapStateToProps(state) {
    const {language} = state.languageReducer;

    return {
        language
    };
}

const connectedDateFormField = connect(mapStateToProps)(DateFormField);
export {connectedDateFormField as DateFormField};
